// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PermissionActionName, PermissionActionNameSchema } from 'api/gen/PermissionActionName';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PermissionCode, PermissionCodeSchema } from 'api/gen/PermissionCode';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PermissionComment, PermissionCommentSchema } from 'api/gen/PermissionComment';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PermissionControllerName, PermissionControllerNameSchema } from 'api/gen/PermissionControllerName';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';

const requiredPart = t.interface({
  actionName: PermissionActionNameSchema,
  code: PermissionCodeSchema,
  comment: t.union([PermissionCommentSchema, t.null]),
  controllerName: PermissionControllerNameSchema,
  discriminatorId: PositiveIntegerSchema,
  userEnable: t.boolean,
});

export const CreatePermissionSchema = excess(requiredPart);

export interface CreatePermission extends t.TypeOf<typeof CreatePermissionSchema> {}
